import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7 },
};

const audiences = [
  ["Government agencies", "Departments and agencies whose systems hold or affect First Nations governance, data and heritage."],
  ["Universities & research bodies", "Institutions working with Indigenous data, collections and community partnerships."],
  ["Cultural institutions", "Libraries, archives and museums holding records connected to Country and community."],
  ["First Nations organisations", "Community-controlled organisations asserting governance over their own data and systems."],
];

export default function Audience() {
  return (
    <section data-testid="home-audience" className="py-24 md:py-32 border-b border-line">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.p {...fadeUp} className="font-mono text-xs uppercase tracking-[0.3em] text-ochre mb-6">Who it is for</motion.p>
        <motion.h2 {...fadeUp} className="font-serif text-3xl md:text-5xl tracking-tight mb-16 max-w-3xl">
          The governance remains yours. <em className="text-ember">Bigibila provides the methodology.</em>
        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-line/40 border border-line/40">
          {audiences.map(([title, desc], i) => (
            <motion.div key={title} {...fadeUp} transition={{ duration: 0.6, delay: i * 0.07 }} data-testid={`audience-${i}`} className="bg-ink p-8 hover:bg-surface1 transition-colors duration-300">
              <h3 className="font-serif text-xl mb-3">{title}</h3>
              <p className="text-sm text-stone2 leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
